const tab0 = require.context(
    '@/assets/img/landing/example/template_0/chaichu',
    false,
    /\.png$/
);
const tab1 = require.context(
    '@/assets/img/landing/example/template_0/shuidian',
    false,
    /\.png$/
);
const tab2 = require.context(
    '@/assets/img/landing/example/template_0/wagong',
    false,
    /\.png$/
);
const tab3 = require.context(
    '@/assets/img/landing/example/template_0/mugong',
    false,
    /\.png$/
);
const tab4 = require.context(
    '@/assets/img/landing/example/template_0/yougong',
    false,
    /\.png$/
);
const tab5 = require.context(
    '@/assets/img/landing/example/template_0/anzhuanggongcheng',
    false,
    /\.png$/
);
const tab6 = require.context(
    '@/assets/img/landing/example/template_0/baojie',
    false,
    /\.png$/
);
const createList = MODULES => {
    return MODULES.keys().reduce((store, PATH) => {
        if (PATH === './index.js') return store;
        store.push(MODULES(PATH).default);
        return store;
    }, []);
};

export const imgGroup = {
    0: createList(tab0),
    1: createList(tab1),
    2: createList(tab2),
    3: createList(tab3),
    4: createList(tab4),
    5: createList(tab5),
    6: createList(tab6),
};
